module.exports = "#version 100\r\nprecision highp float;\r\n\r\nuniform sampler2D u_colorTexture;\r\nuniform sampler2D u_hightlightTexture;\r\n\r\nvarying vec2 v_uv;\r\n\r\nvoid main() {\r\n\r\n    vec3 fragColor = vec3(0.0);\r\n\r\n    vec3 sceneColor     = texture2D(u_colorTexture, v_uv).rgb;\r\n    vec3 highlightColor = texture2D(u_hightlightTexture, v_uv).rgb;\r\n\r\n    gl_FragColor = vec4(0.8 * sceneColor + 2.5 * highlightColor, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/combineFragment.frag.glsl
// module id = 12
// module chunks = 0